import { Box, Checkbox } from '@chakra-ui/react';
import {
  isSessionCategory,
  SessionCategoryPrefix,
  type Msg,
  type Session,
} from '@halo/chat-sdk-react';
import { ConfirmDialog } from '@halo/ui-chat-react';

export interface DeleteMessagesDialogProps {
  open: boolean;
  onClose: () => void;
  deleteOtherMessagesAllow: boolean;
  deleteOtherMessages: boolean;
  setDeleteOtherMessages: (deleteOtherMessages: boolean) => void;
  deleteMessagesSession: Session | null;
  deleteMessages: Msg[];
  onOk: () => Promise<void>;
}

export const DeleteMessagesDialog = ({
  open,
  onClose,
  deleteOtherMessagesAllow,
  deleteOtherMessages,
  setDeleteOtherMessages,
  deleteMessagesSession,
  onOk,
}: DeleteMessagesDialogProps) => {
  const { t } = useTranslation();
  const isGroup = isSessionCategory(deleteMessagesSession?.chat_id, SessionCategoryPrefix.Group);

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      title={t('chat.deleteMessagesTitle')}
      onOk={() => onOk()}
      contentProps={{
        w: '428px',
      }}
    >
      <Box py="6">
        {open && deleteOtherMessagesAllow && (
          <Checkbox.Root
            size="sm"
            defaultChecked={deleteOtherMessages}
            onCheckedChange={(e) => setDeleteOtherMessages(!!e.checked)}
            cursor="pointer"
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control cursor="pointer" borderRadius="sm" />
            {isGroup ? (
              <Checkbox.Label>{t('chat.deleteMessagesForEveryone')}</Checkbox.Label>
            ) : (
              <Checkbox.Label>
                {t('chat.deleteMessagesForSession', { name: deleteMessagesSession?.name })}
              </Checkbox.Label>
            )}
          </Checkbox.Root>
        )}
      </Box>
    </ConfirmDialog>
  );
};
